import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Services } from './pages/Services';
import { PatientInfo } from './pages/PatientInfo';
import { Resources } from './pages/Resources';
import { Contact } from './pages/Contact';
import { FloatingCTA } from './components/FloatingCTA';
import { HIPAAPrivacyNotice } from './pages/legal/HIPAAPrivacyNotice';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about/*" element={<About />} />
          <Route path="/services/*" element={<Services />} />
          <Route path="/patient-info/*" element={<PatientInfo />} />
          <Route path="/resources/*" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/hipaa-privacy-notice" element={<HIPAAPrivacyNotice />} />
        </Routes>
        <FloatingCTA />
      </Layout>
    </Router>
  );
}

export default App;